import cn from "classnames";
import EvaIcon from "../../images/embedded_video_icon.svg?react";
import styles from "./embeddedVideoIcon.module.scss";

export interface Props {
  className?: string;
}

const EmbeddedVideoIcon: React.FC<Props> = ({ className }): React.ReactElement => (
  <EvaIcon className={cn(styles.evaIcon, className)} />
);

export default EmbeddedVideoIcon;
